import loadable from '@loadable/component'
import {createOverlayType} from '../../../contexts/overlay-manager'

const ConfirmationModalLoadable = loadable(() => import('./internal'))

export const {
    useOverlay: useConfirmationOverlay,
    useIsOpen: useIsConfirmationOverlayOpen,
    preload: preloadConfirmationOverlay
} = createOverlayType(ConfirmationModalLoadable)
